import gql from "graphql-tag";
import { doQuery, doMutation } from "../../core-module/util/graphqlHelper";

export const getActiveSessions = (onlyMine = null) => {
  const query = gql`
    query GetActiveSessions($onlyMine: Boolean) {
      getActiveSessions(onlyMine: $onlyMine) {
        id
        userId
        userName
        userEmail
        userRole
        ipAddress
        country
        city
        browser
        os
        deviceId
        isActive
        isCurrent
        lastActiveAt
        createdAt
      }
    }
  `;
  const variables = onlyMine !== null ? { onlyMine } : {};
  return doQuery({ query, variables, fetchPolicy: "network-only" }).then(({ data, error }) => {
    if (data) return { data: data.getActiveSessions };
    return { error };
  });
};

export const revokeSession = id => {
  const mutation = gql`
    mutation RevokeSession($id: ID!) {
      revokeSession(id: $id)
    }
  `;
  return doMutation({ mutation, variables: { id } }).then(({ data, error }) => {
    if (data) return { data: data.revokeSession };
    return { error };
  });
};

export const revokeAllOtherSessions = () => {
  const mutation = gql`
    mutation RevokeAllOtherSessions {
      revokeAllOtherSessions
    }
  `;
  return doMutation({ mutation }).then(({ data, error }) => {
    if (data) return { data: data.revokeAllOtherSessions };
    return { error };
  });
};
